var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement, property } from 'lit/decorators.js';
let RadioGroupComponent = class RadioGroupComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.options = [];
        this.selectedValue = '';
        this.name = Math.random().toString(36).substring(8);
    }
    static get styles() {
        return [
            ...super.styles,
            css `
        .slds-radio_button-group {
          display: inline-flex; /* Utilise inline-flex au lieu de flex */
          width: auto; /* S'ajuste à la taille de son contenu */
        }
        .slds-radio_button__label:hover {
          background: #f3f3f3;
        }
      `,
        ];
    }
    _handleChange(e) {
        const target = e.target;
        this.selectedValue = target.value;
        this.dispatchEvent(new CustomEvent('changed', { detail: this.selectedValue }));
    }
    render() {
        return html `
      <div class="slds-form-element">
        <div class="slds-form-element__control">
          <div class="slds-radio_button-group">
            ${this.options.map((option) => html `
                <span class="slds-button slds-radio_button">
                  <input
                    type="radio"
                    id="${option.value}"
                    name="${this.name}"
                    value="${option.value}"
                    ?checked="${this.selectedValue === option.value}"
                    @change="${this._handleChange}"
                  />
                  <label class="slds-radio_button__label" for="${option.value}">
                    <span class="slds-radio_faux">${option.label}</span>
                  </label>
                </span>
              `)}
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Array })
], RadioGroupComponent.prototype, "options", void 0);
__decorate([
    property({ type: String })
], RadioGroupComponent.prototype, "selectedValue", void 0);
RadioGroupComponent = __decorate([
    customElement('ggo-radio-group')
], RadioGroupComponent);
export { RadioGroupComponent };
